module.exports = __webpack_public_path__ + "img/car.5514aa43.jpg";